import { AlertProps } from '@material-ui/lab/Alert';

const MuiAlert: AlertProps = {
    closeText: 'Fechar',
};

export default MuiAlert;
